
/** 用于定义强制读取场景的不同类型 */
export enum ForceReadSceneEnum {
  /**
   * 该场景用于标识在授信环节中，针对超级会员的购买场景。
   */
  CREDIT_SUPER_MEMBER,
  /**
   * 该场景用于标识在贷款申请过程中，针对超级会员的购买场景。
   */
  LOAN_SUPER_MEMBER,
  /**
   * 该场景用于标识在贷款申请过程中，针对臻享卡的购买场景。
   */
  LOAN_ZHEN_XIANG_CARD,
}

export enum ContractReadStatusEnum {
  INIT = 1,
  NOT_NEED_READ = 2,
  NEED_READ_HAS_READ = 3,
  NEED_READ_NOT_READ = 4,
}
